<template>
    <div class="page-content">
        <h3>Módulo de Cuenta de Usuario</h3>
        <hr />

        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'account-page',
};
</script>